






import Vue from 'vue';
import Component from 'vue-class-component';
import config from '../config';

const stripInsertions = (name: string) => {
  const insertions = ['van', 'de', '\'t', 'het', 'den'];

  let modifiedName = name;

  insertions.forEach((insertion) => {
    modifiedName = modifiedName.replace(`${insertion} `, '');
  });

  return modifiedName;
};

const AvatarProps = Vue.extend({
  props: {
    name: {
      type: String,
    },

    avatar: {
      type: String,
    },
  },
});

@Component({
  name: 'Avatar',
})
export default class Avatar extends AvatarProps {
  get initials() {
    const nameSplit = stripInsertions(this.name).split(' ');
    const initials = nameSplit.map((word) => word.slice(0, 1)).slice(0, 3);

    return initials.join('');
  }

  get avatarPath() {
    if (!this.avatar) {
      return null;
    }

    return `${config.avatarUrl}${this.avatar}`;
  }
}
